import { Skeleton } from "@mui/material";
import { usePartyQuery } from "Api/Queries/Party/usePartyQuery";
import { useAdminUserDataQuery } from "Api/Queries/User/useAdminUserDataQuery";
import { useVerificationsQuery } from "Api/Queries/Verifications/useVerificationsQuery";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { UserDetailPageContent } from "Components/Users/UserDetailPageContent/UserDetailPageContent";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router-dom";
import { Resources, useResource } from "Translations/Resources";

const UserDetailPage = () => {
  const { id } = useParams();
  const { t } = useResource();

  const { data: userDetailData, isLoading: isUserDetailDataLoading } =
    useAdminUserDataQuery(Number(id));

  const { data: verificationData, isLoading: isVerificationLoading } =
    useVerificationsQuery(Number(id) || undefined);

  const { data: partyData, isLoading: isPartyLoading } = usePartyQuery(
    userDetailData?.partyPublicID,
  );

  const isAllDataReady = userDetailData && partyData && verificationData;
  const isLoading =
    isUserDetailDataLoading || isVerificationLoading || isPartyLoading;

  if (isLoading) {
    return (
      <AuthenticatedLayout title={t(Resources.Pages.Titles.User)}>
        <StyledPageWrapper>
          <div className="left-content">
            <Skeleton height={48} variant="rounded" sx={{ mt: "0.25rem" }} />
            <Skeleton height={800} variant="rounded" sx={{ mt: "0.5rem" }} />
          </div>
        </StyledPageWrapper>
      </AuthenticatedLayout>
    );
  }

  if (isAllDataReady) {
    return (
      <AuthenticatedLayout
        title={userDetailData.login}
        backNavigation={{
          mode: "historyStack",
          fallbackUrl: appUrl("user-list"),
        }}
      >
        <StyledPageWrapper>
          <div className="left-content">
            <UserDetailPageContent
              user={userDetailData}
              verification={{
                ...verificationData,
                requestedUserID: verificationData.userID,
              }}
              legacySourceOfIncome={verificationData.legacySourceOfIncome}
              party={partyData}
            />
          </div>
        </StyledPageWrapper>
      </AuthenticatedLayout>
    );
  }

  return (
    <AuthenticatedLayout title={t(Resources.Error.Unexpected)}>
      {t(Resources.Error.Unexpected)}
    </AuthenticatedLayout>
  );
};

export default UserDetailPage;
